<div class="cust-height">
  <div class="col-12 md:col-12">
    <p-table
      #dt
      selectionMode="single"
      [columns]="listColumns"
      [value]="deleteDocs"
      [rows]="100"
      [paginator]="true"
      responsiveLayout="stack"
      [breakpoint]="'960px'"
      >
      <ng-template pTemplate="caption">
        <span class="header-grid-wrapper">
          <span class="align-right">{{'Delete_List' | translate}} {{'Tot' | translate}} {{ deleteDocs.length }} {{'Doc_Bmm' | translate}}</span>
        </span>
      </ng-template>
      <ng-template let-columns pTemplate="header">
        <tr>
          @for (col of columns; track col; let i = $index) {
            <th
              [pSortableColumn]="col.sort"
                        [ngClass]="{
                            'width-col-13': col.type === 'DateTime',
                            'width-auto': col.type !== 'DateTime'
                        }"
              >
              @if (col.sort !== null) {
                <p-sortIcon [field]="col.sort"></p-sortIcon>
              }
              {{ col.header }}
              @if (col.field === 'doc_archiv') {
                <p-dropdown
                  appendTo="body"
                  [options]="archivList"
                  [style]="{ width: '100%' }"
                  (onChange)="dt.filter($event.value, col.field, 'equals')"
                ></p-dropdown>
              }
              @if (col.field !== 'doc_archiv') {
                <input
                  (click)="$event.stopPropagation()"
                  pInputText
                  type="text"
                  (input)="dt.filter($event.target.value, col.field, 'contains')"
                  style="color: darkgrey"
                  />
              }
            </th>
          }
        </tr>
      </ng-template>
      <ng-template let-rowData let-columns="columns" pTemplate="body">
        <tr [pSelectableRow]="rowData">
          @for (col of columns; track col; let i = $index) {
            <td class="width-auto">
              @switch (col.field) {
                @case ('doc_creationdate') {
                  <div class="align-left">
                    {{ rowData[col.field] | datelength | datecompat | date: 'dd/MM/yyyy HH:mm:ss' }}
                  </div>
                }
                @case ('doc_deletedate') {
                  <div class="align-left">
                    {{ rowData[col.field] | datelength | datecompat | date: 'dd/MM/yyyy HH:mm:ss' }}
                  </div>
                }
                @case ('doc_archiv') {
                  <div class="align">
                    @if (rowData[col.field] === 1) {
                      <i class="pi pi-check md-18" style="color: green"></i>
                    }
                    @if (rowData[col.field] === 0) {
                      <i class="pi pi-times md-18" style="color: red"></i>
                    }
                  </div>
                }
                @default {
                  {{ rowData[col.field] }}
                }
              }
            </td>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7">{{'Empty' | translate}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>


